/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { MediaVersionFromJSON, MediaVersionToJSON, } from './MediaVersion';
/**
 * Check if a given object implements the MediaDownloadResponse interface.
 */
export function instanceOfMediaDownloadResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function MediaDownloadResponseFromJSON(json) {
    return MediaDownloadResponseFromJSONTyped(json, false);
}
export function MediaDownloadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'version': !exists(json, 'version') ? undefined : MediaVersionFromJSON(json['version']),
        'url': !exists(json, 'url') ? undefined : json['url'],
    };
}
export function MediaDownloadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'version': MediaVersionToJSON(value.version),
        'url': value.url,
    };
}
